export default "__VITE_ASSET__404ee799__"